export default __webpack_public_path__ + "static/media/IMG-20240729-WA0033.31f2614f.jpg";